import React, { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, Clock, XCircle, ShoppingBag, ArrowRight } from "lucide-react";
import { MKT_GOLD } from "../../lib/marketplace";
import { apiOrderStatus } from "../../lib/marketplaceApi";
import { useCart } from "../../context/CartContext";

export default function PagoExitoMarketplace() {
  const [params] = useSearchParams();
  const orderId = params.get("order_id");
  const { refresh } = useCart();
  const [estado, setEstado] = useState("pending");
  const intentos = useRef(0);

  useEffect(() => {
    if (!orderId) { setEstado("error"); return; }
    let activo = true;
    const poll = async () => {
      try {
        const d = await apiOrderStatus(orderId);
        if (!activo) return;
        if (d.payment_status === "paid") { setEstado("paid"); refresh(); return; }
        if (d.status === "rejected" || d.payment_status === "rejected") { setEstado("rejected"); return; }
      } catch (_) { /* reintenta */ }
      intentos.current += 1;
      if (intentos.current < 12 && activo) setTimeout(poll, 2500);
      else if (activo) setEstado((e) => (e === "paid" ? e : "pending_timeout"));
    };
    poll();
    return () => { activo = false; };
  }, [orderId, refresh]);

  const cfg = {
    pending: { Icon: Loader2, spin: true, color: MKT_GOLD, titulo: "Confirmando tu pago…", texto: "Esto toma solo unos segundos." },
    pending_timeout: { Icon: Clock, color: "#CA8A04", titulo: "Pago en proceso", texto: "Tu pago se está confirmando. En cuanto se apruebe, tus recursos aparecerán en Mis Compras." },
    paid: { Icon: CheckCircle2, color: "#16A34A", titulo: "¡Pago confirmado!", texto: "Tus recursos ya están disponibles en Mis Compras." },
    rejected: { Icon: XCircle, color: "#DC2626", titulo: "Pago rechazado", texto: "No se pudo procesar tu pago. Intenta nuevamente desde el carrito." },
    error: { Icon: XCircle, color: "#DC2626", titulo: "Orden no encontrada", texto: "No pudimos identificar tu orden." },
  }[estado];
  const { Icon } = cfg;

  return (
    <div className="max-w-lg mx-auto text-center py-24 px-4" data-testid="pago-exito-mkt" data-estado={estado}>
      <Icon size={52} className={`mx-auto ${cfg.spin ? "animate-spin" : ""}`} style={{ color: cfg.color }} />
      <h1 className="mt-5 text-2xl font-extrabold text-slate-900" data-testid="pago-titulo">{cfg.titulo}</h1>
      <p className="mt-2 text-slate-500">{cfg.texto}</p>
      <div className="mt-7 flex flex-col sm:flex-row gap-3 justify-center">
        <Link to="/tienda/mis-compras" data-testid="pago-ir-compras" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl text-white font-bold" style={{ backgroundColor: MKT_GOLD }}>
          <ShoppingBag size={18} /> Ir a Mis Compras
        </Link>
        <Link to="/tienda" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl border border-slate-300 text-slate-700 font-bold hover:bg-slate-100">
          Seguir explorando <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  );
}
